import { createReducer } from 'reduxsauce'
import { INITIAL_STATE } from './initialState'
import { CardTypes } from './Actions'
import RequestState from 'Enums/RequestState'
import InfinityEnums from 'Enums/InfinityEnums'
import history from 'history/browser'
import { cardsFilter } from 'Constants/Filters'

export const fetchCardListLoading = (state) => {
  return {
    ...state,
    fetchCardListRequestState: RequestState.LOADING,
  }
}

export const fetchCardListLoadingMore = (state) => {
  return {
    ...state,
    fetchCardListRequestState: RequestState.LOADING_MORE,
  }
}

export const fetchCardListSuccess = (
  state,
  { offset, cards, nextOffset, newCard, index },
) => {
  let result = []
  for (let j = 0; j < cards.length; j++) {
    if (!state.cards.some((card) => card._id === cards[j]._id)) {
      result.push(cards[j])
    }
  }

  const onCardsPage =
    window.location.pathname.toLocaleLowerCase().indexOf('cards') !== -1 ||
    history.location.pathname.indexOf('cards') !== -1
  if (onCardsPage) {
    if (offset === 0) {
      if (cards && cards.length !== 0) {
        if (newCard !== null && newCard !== undefined) {
          history.push({
            pathname: `/cards/${newCard._id}`,
          })
          return {
            ...state,
            cards: [...cards, newCard],
            paginationOffset: nextOffset,
            fetchCardListRequestState: RequestState.SUCCEEDED,
            selectedIndex: index + 1,
            selectedCard: newCard,
          }
        } else {
          let card = cards[index]
          history.push({
            pathname: `/cards/${card._id}`,
          })
          return {
            ...state,
            cards: [...cards],
            paginationOffset: nextOffset,
            fetchCardListRequestState: RequestState.SUCCEEDED,
            selectedIndex: index,
            selectedCard: card,
          }
        }
      } else {
        return {
          ...state,
          cards: [...cards],
          paginationOffset: nextOffset,
          fetchCardListRequestState: RequestState.SUCCEEDED,
          selectedIndex: -1,
          selectedCard: null,
        }
      }
    } else {
      let selectedIndex = 0
      const cardsList = state.cards
      if (cardsList.length !== 0) {
        const stateSelectedIndex = state.selectedIndex
        const selectedCard = cardsList[stateSelectedIndex]
        let cardOutOfPlace = false
        if (cards[0] && selectedCard.updatedAt < cards[0]['updatedAt'])
          cardOutOfPlace = true
        if (cardOutOfPlace) {
          const outOfPlaceCardIndex = cards.findIndex(
            (card) => card._id === selectedCard._id,
          )
          if (outOfPlaceCardIndex !== -1)
            selectedIndex = cardsList.length + outOfPlaceCardIndex - 1
          else selectedIndex = cardsList.length + cards.length - 1
        } else selectedIndex = state.selectedIndex
      }
      let combinedCards = [...state.cards, ...result]
      combinedCards.sort((a, b) => (a.updatedAt > b.updatedAt ? -1 : 1))
      return {
        ...state,
        cards: combinedCards,
        paginationOffset: nextOffset,
        fetchCardListRequestState: RequestState.SUCCEEDED,
        selectedIndex: selectedIndex,
        selectedCard: combinedCards[selectedIndex],
      }
    }
  } else {
    return {
      ...state,
      fetchCardListRequestState: RequestState.UNINITIALIZED,
    }
  }
}

export const fetchCardListFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchCardListRequestState: requestState,
  }
}

export const deleteCardLoading = (state) => {
  return {
    ...state,
    deleteCardRequestState: RequestState.LOADING,
  }
}

export const deleteCardSuccess = (state, { cardId }) => {
  let newCards = state.cards.filter((card) => card._id !== cardId)
  return {
    ...state,
    cards: [...newCards],
    selectedIndex: 0,
    selectedCard: newCards.length === 0 ? null : newCards[0],
    deleteCardRequestState: RequestState.SUCCEEDED,
    cardsCount: state.cardsCount - 1,
  }
}

export const deleteCardFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    deleteCardRequestState: requestState,
  }
}

export const updateCardLoading = (state) => {
  return {
    ...state,
    updateCardRequestState: RequestState.LOADING,
  }
}

export const updateCardSuccess = (state, { index, newCard }) => {
  let newCards = state.cards
  let selectedCard = state.selectedCard

  if (index < 0) {
    return
  } else {
    const newObject = {
      ...newCards[index],
    }
    if (newCard.parentId) {
      newObject.parentId = newCard.parentId
      selectedCard.parentId = newCard.parentId
    }
    if (newCard.huid) {
      newObject.huid = newCard.huid
      selectedCard.huid = newCard.huid
    }
    if (newCard.contractId) {
      newObject.contractId = newCard.contractId
      selectedCard.contractId = newCard.contractId
    }
    if (newCard.type) {
      newObject.type = newCard.type
      selectedCard.type = newCard.type
    }
    if (newCard.status) {
      newObject.status = newCard.status
      selectedCard.status = newCard.status
    }
    newCards[index] = newObject
    return {
      ...state,
      cards: [...newCards],
      selectedCard: selectedCard,
      updateCardRequestState: RequestState.SUCCEEDED,
    }
  }
}

export const updateCardFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    updateCardRequestState: requestState,
  }
}

export const clearCards = (state) => {
  return {
    ...state,
    cards: [],
    paginationOffset: 0,
    fetchCardSessionListRequestState: RequestState.UNINITIALIZED,
  }
}

export const setCardsFilter = (state, { newFilter }) => {
  return {
    ...state,
    cardsFilter: newFilter,
  }
}

// Restores the cards filter to its default (a fresh deep clone so the
// "Mine"-only default is re-applied whenever the user lands on the page).
export const resetCardsFilter = (state) => {
  return {
    ...state,
    cardsFilter: JSON.parse(JSON.stringify(cardsFilter)),
  }
}

export const addCardLoading = (state) => {
  return {
    ...state,
    addCardRequestState: RequestState.LOADING,
  }
}

export const addCardSuccess = (state, { newCard }) => {
  return {
    ...state,
    cards: [newCard, ...state.cards],
    addCardRequestState: RequestState.SUCCEEDED,
    cardsCount: state.cardsCount + 1,
    selectedCard: newCard,
    selectedIndex: 0,
  }
}

export const addCardFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    addCardRequestState: requestState,
  }
}

export const addCardBulkSuccess = (state, { newCards }) => {
  return {
    ...state,
    cards: [...state.cards, ...newCards],
    addCardRequestState: RequestState.SUCCEEDED,
    cardsCount: state.cardsCount + newCards.length,
  }
}

export const resetCardRequestStates = (state) => {
  return {
    ...state,
    fetchCardListRequestState: RequestState.UNINITIALIZED,
    deleteCardRequestState: RequestState.UNINITIALIZED,
    updateCardRequestState: RequestState.UNINITIALIZED,
    addCardRequestState: RequestState.UNINITIALIZED,
    cardsFilter: [...JSON.parse(JSON.stringify(INITIAL_STATE.cardsFilter))],
  }
}
export const resetUpdateCardRequestStates = (state) => {
  return {
    ...state,
    updateCardRequestState: RequestState.UNINITIALIZED,
    addCardAccessGroupsRequestState: RequestState.UNINITIALIZED,
    deleteCardAccessGroupsRequestState: RequestState.UNINITIALIZED,
  }
}

export const fetchCardTransactionsLoading = (state) => {
  return {
    ...state,
    fetchCardTransactionsRequestState: RequestState.LOADING,
  }
}

export const fetchCardTransactionsLoadingMore = (state) => {
  return {
    ...state,
    fetchCardTransactionsRequestState: RequestState.LOADING_MORE,
  }
}

export const fetchCardTransactionsSuccess = (
  state,
  { offset, chargingTokenTransactions, nextOffset },
) => {
  let result = []
  for (let j = 0; j < chargingTokenTransactions.length; j++) {
    if (
      !state.cardTransactions.some(
        (cardTransaction) =>
          cardTransaction._id === chargingTokenTransactions[j]._id,
      )
    ) {
      result.push(chargingTokenTransactions[j])
    }
  }
  if (offset === 0) {
    return {
      ...state,
      cardTransactions: [...chargingTokenTransactions],
      cardTransactionsPaginationOffset: nextOffset,
      fetchCardTransactionsRequestState: RequestState.SUCCEEDED,
    }
  } else {
    return {
      ...state,
      cardTransactions: [...state.cardTransactions, ...result],
      cardTransactionsPaginationOffset: nextOffset,
      fetchCardTransactionsRequestState: RequestState.SUCCEEDED,
    }
  }
}

export const fetchCardTransactionsFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchCardTransactionsRequestState: requestState,
  }
}

export const setCardTransactionsFilter = (state, { newFilter }) => {
  return {
    ...state,
    cardsTransactionsFilter: newFilter,
  }
}

export const setCardSelectedIndex = (state, { index }) => {
  let newSelectedCard
  if (index === state.selectedIndex) {
    newSelectedCard = state.selectedCard
  } else {
    newSelectedCard = state.cards[index]
  }
  return {
    ...state,
    selectedCard: newSelectedCard,
    selectedIndex: index,
  }
}

export const fetchCardLoading = (state) => {
  return {
    ...state,
    fetchCardRequestState: RequestState.LOADING,
  }
}

export const fetchCardSuccess = (state, { card }) => {
  const newCard = {
    ...card.chargingToken,
    accessGroups: card.accessGroups,
  }
  return {
    ...state,
    selectedCard: newCard,
    fetchCardRequestState: RequestState.SUCCEEDED,
  }
}

export const fetchCardFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchCardRequestState: requestState,
  }
}

export const addCardAccessGroupsLoading = (state) => {
  return {
    ...state,
    addCardAccessGroupsRequestState: RequestState.LOADING,
  }
}

export const addCardAccessGroupsSuccess = (state, { accessGroups }) => {
  const groups = [
    ...new Set(state.selectedCard.accessGroups.concat(accessGroups)),
  ]
  const updatedCard = { ...state.selectedCard }
  updatedCard.accessGroups = groups
  return {
    ...state,
    selectedCard: updatedCard,
    addCardAccessGroupsRequestState: RequestState.SUCCEEDED,
  }
}

export const addCardAccessGroupsFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    addCardAccessGroupsRequestState: requestState,
  }
}

export const deleteCardAccessGroupsLoading = (state) => {
  return {
    ...state,
    deleteCardAccessGroupsRequestState: RequestState.LOADING,
  }
}

export const deleteCardAccessGroupsSuccess = (state, { accessGroups }) => {
  const oldAccessGroups = state.selectedCard.accessGroups
  const filteredAccessGroups = oldAccessGroups.filter((group) => {
    return accessGroups.indexOf(group._id) === -1
  })
  const updatedCard = { ...state.selectedCard }
  updatedCard.accessGroups = filteredAccessGroups
  return {
    ...state,
    selectedCard: updatedCard,
    deleteCardAccessGroupsRequestState: RequestState.SUCCEEDED,
  }
}

export const deleteCardAccessGroupsFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    deleteCardAccessGroupsRequestState: requestState,
  }
}

export const clearCardTransactions = (state) => {
  return {
    ...state,
    cardTransactions: [],
    fetchCardTransactionsRequestState: RequestState.UNINITIALIZED,
    cardTransactionsPaginationOffset: 0,
  }
}
export const resetCardState = (state) => {
  return {
    ...state,
    fetchCardTransactionsRequestState: RequestState.UNINITIALIZED,
    cardTransactionsPaginationOffset: 0,
    cardsTransactionsFilter: [
      ...JSON.parse(JSON.stringify(INITIAL_STATE.cardsTransactionsFilter)),
    ],
  }
}

export const setPaginationOffset = (state, { offset }) => {
  return {
    ...state,
    paginationOffset: offset,
  }
}

export const setCardsTransactionPaginationOffset = (state, { offset }) => {
  return {
    ...state,
    cardsTransactionPaginationOffset: offset,
  }
}

export const fetchCardListCountLoading = (state) => {
  return {
    ...state,
    fetchCardListCountRequestState: RequestState.LOADING,
  }
}

export const fetchCardListCountSuccess = (state, { cardsCount }) => {
  return {
    ...state,
    cardsCount: cardsCount,
    fetchCardListCountRequestState: RequestState.SUCCEEDED,
  }
}

export const fetchCardListCountFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchCardListCountRequestState: requestState,
  }
}

export const fetchLocalListFilteredCardsLoading = (state) => {
  return {
    ...state,
    fetchLocalListFilteredCardsRequestState: RequestState.LOADING,
  }
}

export const fetchLocalListFilteredCardsSuccess = (
  state,
  { offset, cards, nextOffset },
) => {
  let result = []
  for (let j = 0; j < cards.length; j++) {
    if (!state.cards.some((card) => card._id === cards[j]._id)) {
      result.push(cards[j])
    }
  }

  if (offset === 0) {
    return {
      ...state,
      localListFilteredCards: [...cards],
      localListFilteredCardsPaginationOffset: nextOffset,
      fetchLocalListFilteredCardsRequestState: RequestState.SUCCEEDED,
    }
  } else {
    let combinedTokens = [...state.localListFilteredCards, ...result]
    combinedTokens.sort((a, b) => (a.updatedAt > b.updatedAt ? -1 : 1))

    return {
      ...state,
      localListFilteredCards: combinedTokens,
      localListFilteredCardsPaginationOffset: nextOffset,
      fetchLocalListFilteredCardsRequestState: RequestState.SUCCEEDED,
    }
  }
}

export const fetchLocalListFilteredCardsFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchLocalListFilteredCardsRequestState: requestState,
  }
}
export const clearLocalListFilteredCards = (state) => {
  return {
    ...state,
    localListFilteredCards: [],
    localListFilteredCardsPaginationOffset: 0,
  }
}

export const fetchSessionListCardLoading = (state) => {
  return {
    ...state,
    fetchSessionListCardRequestState: RequestState.LOADING,
  }
}

export const fetchSessionListCardSuccess = (state, { sessions }) => {
  return {
    ...state,
    cardSessions: sessions,
    fetchSessionListCardRequestState: RequestState.SUCCEEDED,
  }
}

export const fetchSessionListCardFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchSessionListCardRequestState: requestState,
  }
}

export const fetchCardTransactionStatsLoading = (state) => {
  return {
    ...state,
    fetchCardTransactionStatsRequestState: RequestState.LOADING,
  }
}

export const fetchCardTransactionStatsSuccess = (state, { stats }) => {
  return {
    ...state,
    cardTransactionStats: stats,
    fetchCardTransactionStatsRequestState: RequestState.SUCCEEDED,
  }
}

export const fetchCardTransactionStatsFail = (state, { error }) => {
  let requestState = RequestState.ERROR_UNKNOWN_OCCURRED
  if (error && error.message === 'Network Error') {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 503) {
    requestState = RequestState.ERROR_0_NETWORK
  } else if (error && error.status === 409) {
    requestState = RequestState.ERROR_409_OCCURRED
  } else if (error && error.status === 400) {
    requestState = RequestState.ERROR_400_OCCURRED
  }
  return {
    ...state,
    fetchCardTransactionStatsRequestState: requestState,
  }
}

export const clearCardTransactionStats = (state) => {
  return {
    ...state,
    cardTransactionStats: null,
    fetchCardTransactionStatsRequestState: RequestState.UNINITIALIZED,
  }
}

export const emitterUpdateCardSessionStatus = (state, { session }) => {
  if (session.huid) {
    let newSessions = state.cardSessions

    for (const oldSession of newSessions) {
      if (oldSession.chargePoint.huid !== session.huid) continue

      const updatedConnector = session.chargePoint.connectors.find(
        (c) => c.uid === oldSession.connectorUid,
      )
      const evse = oldSession.chargePoint.evses?.find((e) =>
        e.connectors?.some(
          (c) => c.uid?.toString() === oldSession.connectorUid?.toString(),
        ),
      )
      if (!evse?.connectors) continue
      const connectorIndex = evse.connectors.findIndex(
        (c) => c.uid?.toString() === oldSession.connectorUid?.toString(),
      )
      if (connectorIndex === -1) continue
      if (
        updatedConnector?.status === InfinityEnums.ConnectorStatus.AVAILABLE
      ) {
        evse.connectors.splice(connectorIndex, 1)
        if (evse.connectors.length === 0) {
          const sessionIndex = newSessions.findIndex(
            (s) => s.connectorUid === oldSession.connectorUid,
          )
          if (sessionIndex !== -1) {
            newSessions.splice(sessionIndex, 1)
          }
          continue
        }
      } else {
        evse.connectors[connectorIndex] = updatedConnector
      }
    }
    return {
      ...state,
      cardSessions: [...newSessions],
    }
  } else {
    let incomingSession = session.data
    let newSessions = state.cardSessions
    let index = newSessions.findIndex(
      (oldSession) => oldSession._id === incomingSession._id,
    )
    if (index !== -1) {
      if (
        incomingSession.status === InfinityEnums.ChargingSessionStatus.ENDED
      ) {
        newSessions.splice(index, 1)
      } else {
        newSessions[index].transaction = incomingSession.transaction
        newSessions[index].status = incomingSession.status
        newSessions[index].updatedAt = incomingSession.updatedAt
      }
    } else if (incomingSession.chargePoint) {
      newSessions.push(incomingSession)
    } else return { ...state }
    return {
      ...state,
      cardSessions: [...newSessions],
    }
  }
}

export const reducer = createReducer(INITIAL_STATE, {
  [CardTypes.FETCH_CARD_LIST_LOADING]: fetchCardListLoading,
  [CardTypes.FETCH_CARD_LIST_LOADING_MORE]: fetchCardListLoadingMore,
  [CardTypes.FETCH_CARD_LIST_SUCCESS]: fetchCardListSuccess,
  [CardTypes.FETCH_CARD_LIST_FAIL]: fetchCardListFail,
  [CardTypes.UPDATE_CARD_LOADING]: updateCardLoading,
  [CardTypes.UPDATE_CARD_SUCCESS]: updateCardSuccess,
  [CardTypes.UPDATE_CARD_FAIL]: updateCardFail,
  [CardTypes.CLEAR_CARDS]: clearCards,
  [CardTypes.SET_CARDS_FILTER]: setCardsFilter,
  [CardTypes.RESET_CARDS_FILTER]: resetCardsFilter,
  [CardTypes.ADD_CARD_LOADING]: addCardLoading,
  [CardTypes.ADD_CARD_SUCCESS]: addCardSuccess,
  [CardTypes.ADD_CARD_FAIL]: addCardFail,
  [CardTypes.ADD_CARD_BULK_SUCCESS]: addCardBulkSuccess,
  [CardTypes.RESET_CARD_REQUEST_STATES]: resetCardRequestStates,
  [CardTypes.FETCH_CARD_LOADING]: fetchCardLoading,
  [CardTypes.FETCH_CARD_SUCCESS]: fetchCardSuccess,
  [CardTypes.FETCH_CARD_FAIL]: fetchCardFail,
  [CardTypes.ADD_CARD_ACCESS_GROUPS_LOADING]: addCardAccessGroupsLoading,
  [CardTypes.ADD_CARD_ACCESS_GROUPS_SUCCESS]: addCardAccessGroupsSuccess,
  [CardTypes.ADD_CARD_ACCESS_GROUPS_FAIL]: addCardAccessGroupsFail,
  [CardTypes.DELETE_CARD_ACCESS_GROUPS_LOADING]: deleteCardAccessGroupsLoading,
  [CardTypes.DELETE_CARD_ACCESS_GROUPS_SUCCESS]: deleteCardAccessGroupsSuccess,
  [CardTypes.DELETE_CARD_ACCESS_GROUPS_FAIL]: deleteCardAccessGroupsFail,
  [CardTypes.FETCH_CARD_TRANSACTIONS_LOADING]: fetchCardTransactionsLoading,
  [CardTypes.FETCH_CARD_TRANSACTIONS_LOADING_MORE]:
    fetchCardTransactionsLoadingMore,
  [CardTypes.FETCH_CARD_TRANSACTIONS_SUCCESS]: fetchCardTransactionsSuccess,
  [CardTypes.FETCH_CARD_TRANSACTIONS_FAIL]: fetchCardTransactionsFail,
  [CardTypes.SET_CARD_TRANSACTIONS_FILTER]: setCardTransactionsFilter,
  [CardTypes.SET_CARD_SELECTED_INDEX]: setCardSelectedIndex,
  [CardTypes.CLEAR_CARD_TRANSACTIONS]: clearCardTransactions,
  [CardTypes.RESET_CARD_STATE]: resetCardState,
  [CardTypes.FETCH_CARD_LOADING]: fetchCardLoading,
  [CardTypes.FETCH_CARD_SUCCESS]: fetchCardSuccess,
  [CardTypes.FETCH_CARD_FAIL]: fetchCardFail,
  [CardTypes.SET_PAGINATION_OFFSET]: setPaginationOffset,
  [CardTypes.SET_CARDS_TRANSACTION_PAGINATION_OFFSET]:
    setCardsTransactionPaginationOffset,
  [CardTypes.FETCH_CARD_LIST_COUNT_LOADING]: fetchCardListCountLoading,
  [CardTypes.FETCH_CARD_LIST_COUNT_SUCCESS]: fetchCardListCountSuccess,
  [CardTypes.FETCH_CARD_LIST_COUNT_FAIL]: fetchCardListCountFail,
  [CardTypes.DELETE_CARD_LOADING]: deleteCardLoading,
  [CardTypes.DELETE_CARD_SUCCESS]: deleteCardSuccess,
  [CardTypes.DELETE_CARD_FAIL]: deleteCardFail,
  [CardTypes.FETCH_LOCAL_LIST_FILTERED_CARDS_LOADING]:
    fetchLocalListFilteredCardsLoading,
  [CardTypes.FETCH_LOCAL_LIST_FILTERED_CARDS_SUCCESS]:
    fetchLocalListFilteredCardsSuccess,
  [CardTypes.FETCH_LOCAL_LIST_FILTERED_CARDS_FAIL]:
    fetchLocalListFilteredCardsFail,
  [CardTypes.CLEAR_LOCAL_LIST_FILTERED_CARDS]: clearLocalListFilteredCards,
  [CardTypes.RESET_UPDATE_CARD_REQUEST_STATES]: resetUpdateCardRequestStates,
  [CardTypes.FETCH_SESSION_LIST_CARD_LOADING]: fetchSessionListCardLoading,
  [CardTypes.FETCH_SESSION_LIST_CARD_SUCCESS]: fetchSessionListCardSuccess,
  [CardTypes.FETCH_SESSION_LIST_CARD_FAIL]: fetchSessionListCardFail,
  [CardTypes.FETCH_CARD_TRANSACTION_STATS_LOADING]:
    fetchCardTransactionStatsLoading,
  [CardTypes.FETCH_CARD_TRANSACTION_STATS_SUCCESS]:
    fetchCardTransactionStatsSuccess,
  [CardTypes.FETCH_CARD_TRANSACTION_STATS_FAIL]: fetchCardTransactionStatsFail,
  [CardTypes.CLEAR_CARD_TRANSACTION_STATS]: clearCardTransactionStats,
  [CardTypes.EMITTER_UPDATE_CARD_SESSION_STATUS]:
    emitterUpdateCardSessionStatus,
})
